import api from "../utils/axios";
import { useMutation } from "@tanstack/react-query";

// Read-only. Returns what is on the new address today, what would be renamed,
// and the downstream systems the rename does not reach.
export const usePreviewAddressChangeMutation = (options = {}) => {
  return useMutation({
    mutationFn: async ({ propertyId, newAddress }) => {
      const res = await api.post("/admin/addressChange/preview", {
        propertyId,
        newAddress,
      });
      return res.data?.data || null;
    },
    ...options,
  });
};

// Destructive. deletePropertyIds must be exactly the conflicts the preview
// returned — the server refuses the write if the set has moved since.
export const useApplyAddressChangeMutation = (options = {}) => {
  return useMutation({
    mutationFn: async ({ propertyId, newAddress, deletePropertyIds }) => {
      const res = await api.post("/admin/addressChange/apply", {
        propertyId,
        newAddress,
        deletePropertyIds,
        confirm: true,
      });
      return res.data?.data || null;
    },
    ...options,
  });
};
